import { HttpResponse } from '@angular/common/http';
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { AddOnDetail } from 'src/app/classes/add-on-detail';
import { AssignTask } from 'src/app/classes/assign-task';
import { CreateAddOnPayload } from 'src/app/classes/create-addon-payload';
import { DriverTask } from 'src/app/classes/driver-task';
import { Events } from 'src/app/classes/events';
import { RemoveAddOnPayload } from 'src/app/classes/remove-addon-payload';
import { EventsDeltaService } from 'src/app/services/events-delta.service';
import { EventsService } from 'src/app/services/events.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ToastService } from 'src/app/services/toast.service';
import { UnassignedTasksService } from 'src/app/services/unassigned-tasks.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { UnassingedTaskConfirmationDialogComponent } from './unassingned-task-confirmation-dialog/unassingned-task-confirmation-dialog.component';

export interface AddOnFormDetail{
  type: string,
  value: string,
  isActive: boolean
}

@Component({
  standalone: false,
  selector: 'app-unassigned-tasks',
  templateUrl: './unassigned-tasks.component.html',
  styleUrls: ['./unassigned-tasks.component.scss']
})
export class UnassignedTasksComponent implements OnInit, AfterContentChecked{
  warningIcon = faExclamationTriangle as IconProp;
  unAssignedTaskForm: FormGroup;
  events: Events;
  unassignedTasks: DriverTask[];
  unsubscribe$: Subject<boolean> = new Subject();
  noUnassignedTasks = true;
  showAdd: boolean;
  expandedPanel ='-1';
  addItemTypes: any[];
  flightCustoms: Array<string>;
  currentTaskToProcess = '';

  constructor(
    public fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private eventsService: EventsService,
    private eventsDeltaService: EventsDeltaService,
    private utilityService: UtilitiesService,
    public dialog: MatDialog,
    private unassignedTasksService: UnassignedTasksService,
    private profileService: ProfileService,
    private toastService: ToastService,
    // private dispatchService: DispatchService,
    private logger: LoggerService) {

   }

   ngAfterContentChecked():void{
    this.cdr.detectChanges();
   }

   ngOnInit(): void {

    this.buildForm();
    this.addItemTypes = [
      {name: "Passenger", value: "Passenger"},
      {name: "Paperwork", value: "Paperwork"},
      {name: "Catering", value: "Catering"},
      {name: "Other", value: "Other"},
    ]
    this.subscribeToEvents();
    this.subscribeToEventDeltas();
   }

   buildForm(): void {
    this.unAssignedTaskForm = this.fb.group({
      cordNotes: this.fb.control(''),
      driverNotes: this.fb.control(''),
      taskDetails: this.fb.group({})
    });
  }

  setExpandedpanel(data:DriverTask):void{
    // console.log(data);
    // this.getTaskDetails(data.typeName, data.taskName);
    this.expandedPanel=data.taskName;
    this.unAssignedTaskForm.get('cordNotes').setValue(data.specialInstructions);
    this.unAssignedTaskForm.get('driverNotes').setValue(data.driverNotes === 'null' ? '' : data.driverNotes);
  }


  // getTaskDetails(_taskType: string, _taskName: string): void {
  //   // const taskId = _taskName;
  //   const taskId = '614672';
  //   // const taskId = [ TaskType.InboundFlight, TaskType.OutboundFlight ].some((taskType: TaskType) => taskType.toString() === _taskType) ? task.flightId : task.taskName;
  //   this.dispatchService
  //     .getTaskDetails(taskId, _taskType)
  //     .subscribe((taskDetails: DispatchTaskDetails) => {
  //       if (taskDetails) {
  //         console.log(taskDetails);
  //       }
  //     });
  // }

  toggleAddItem(status: boolean): void {
    if (status === false) {
      this.dialog.open(UnassingedTaskConfirmationDialogComponent,{
        width: '550px',
        data: {
          message: 'Are you sure you want to delete this item?'
        }
      }).afterClosed().subscribe(response => {
        if (response) {
          this.showAdd = status;
        }
      });
    } else {
      this.showAdd = status;
    }
  }

  get taskDetails(): FormGroup {
    return this.unAssignedTaskForm.get('taskDetails') as FormGroup;
  }

  newValueTaskDetails(type: string, value: string): FormGroup {
    return this.fb.group({
      type: type,
      value: value,
      isActive: false
    });
  }

  populateAndAddTaskDetails(taskName: string, type: string, value: string, e: any): void {
   if(type === undefined || value === ''){
    this.toastService.show(`Form Error: Please complete all fields`, { classname: 'bg-danger text-light', delay: 4000 });
    return;
   }
    const detailsId: string = this.utilityService.guid();
    const payload: CreateAddOnPayload = {
      type: 'createAddOn',
      updatedBy: this.profileService.profileObs$.getValue().adId,
      newAddOn: {
        id: detailsId,
        type: type,
        name: value
      }
    }
     this.unassignedTasksService.createAddOn(payload, taskName)
     .pipe(tap(() => this.eventsDeltaService.getDeltas()))
     .subscribe((resp:HttpResponse<any>) => {
       this.logger.debug(`PUT createAddOn response:`, resp, 'http');
        if(resp.status === 204){
         // add the new slider control to the form
         this.taskDetails.addControl(
           this.getAddOnFormKey(taskName, detailsId),
           this.newValueTaskDetails(type, value)
         );
         this.unassignedTasks.forEach((driverTask: DriverTask) => {
           if (driverTask.taskName === taskName) {
             driverTask.addOnDetails = driverTask.addOnDetails || [];
             driverTask.addOnDetails.push({ id: detailsId, type, name: value });
           }
         });
         this.showAdd = false;
         e.stopImmediatePropagation();
         this.toastService.show(`Success: Task Updated`, { classname: 'bg-success text-light', delay: 4000 });
       }else{
         this.toastService.show(`Error: ${resp.status} occurred, task was not updated!`, { classname: 'bg-danger text-light', delay: 4000 });
       }
     });
   }

   getDetailsFormControl(driverTaskName: string, detailsId: number | string): FormControl {
    return (this.unAssignedTaskForm.controls['taskDetails'] as FormGroup).controls[
      this.getAddOnFormKey(driverTaskName, detailsId)
    ].get('isActive') as FormControl;
  }

  getAddOnFormKey(driverTaskName: string, passengerId: number | string): string {
    return `${driverTaskName}:${passengerId}`;
  }

  onRemoveTaskDetails(taskName: string, detailId: number | string): void {
    this.dialog.open(UnassingedTaskConfirmationDialogComponent,{
      width: '550px',
      data: {
        message: 'Are you sure you want to delete this item?'
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        this.removeTaskDetails(taskName, detailId);
      }
    });
  }

  removeTaskDetails(taskName: string, detailId: number | string): void {
    const payload: RemoveAddOnPayload = {
      type: 'deleteAddOn',
      deleteAddOnId: detailId,
      deleteBy: this.profileService.profileObs$.getValue().adId
    }
    this.unassignedTasksService.removeAddOn(payload, taskName)
    .pipe(tap(() => this.eventsDeltaService.getDeltas()))
    .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT removeAddOn response:`, resp, 'http');
       if(resp.status === 204){
        // remove the control to the form
        this.unassignedTasks.forEach((driverTask: DriverTask) => {
          if (driverTask.taskName === taskName) {
            driverTask.addOnDetails = driverTask.addOnDetails.filter((details: AddOnDetail) => details.id !== detailId);
          }
        });
        this.taskDetails.removeControl(this.getAddOnFormKey(taskName, detailId));
        this.toastService.show(`Success: Task Updated`, { classname: 'bg-success text-light', delay: 4000 });
      }else{
        this.toastService.show(`Error: ${resp.status} occurred, task was not updated!`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }

  updateFormAddOns(unassignedTasks: DriverTask[]): void {
    const addOnKeys: string[] = [];
    unassignedTasks.forEach((unassignedTask: DriverTask) => {
      if (unassignedTask.addOnDetails) {
        unassignedTask.addOnDetails.forEach((addOnDetails: AddOnDetail) =>
          addOnKeys.push(this.getAddOnFormKey(unassignedTask.taskName, addOnDetails.id))
        );
        unassignedTask.addOnDetails.forEach((details: AddOnDetail) => {
          const addOnKey = this.getAddOnFormKey(unassignedTask.taskName, details.id);
          if (!(this.unAssignedTaskForm.controls['taskDetails'] as FormGroup).contains(addOnKey)) {
            const fg: FormGroup = this.newValueTaskDetails(details.type, details.name);
            (this.unAssignedTaskForm.controls['taskDetails'] as FormGroup).addControl(addOnKey, fg);
          }
        });
        Object.keys(this.unAssignedTaskForm.controls['taskDetails']).forEach((formKey: string) => {
          if (!addOnKeys.includes(formKey)) {
            (this.unAssignedTaskForm.controls['taskDetails'] as FormGroup).removeControl(formKey);
          }
        });
      }
    });
  }

   getdueTime(date: string): any{
    return this.utilityService.timeMath(date);
   }


  subscribeToEvents(): void {
    this.eventsService.getEventData().pipe(takeUntil(this.unsubscribe$))
    .subscribe((events) => {
        if (events) {
          this.events = events;
          this.unassignedTasks = events['unassignedTasks'];
          this.unassignedTasks = this.unassignedTasks.filter(item => item.typeName !== 'OutboundFlight');
          this.updateFormAddOns(this.unassignedTasks);
          this.flightCustoms = events.uiParameters.FLIGHT_CUSTOMS;
          if(this.unassignedTasks && this.unassignedTasks.length>50){
            this.unassignedTasks = this.unassignedTasks.slice(0,50);
          }
          if(this.unassignedTasks && this.unassignedTasks.length > 0){
            this.noUnassignedTasks = false;
          }
        }
      });
  }

  subscribeToEventDeltas(): void {
    this.eventsDeltaService.getEventData().pipe(takeUntil(this.unsubscribe$))
    .subscribe((events) => {
        if (events) {
          this.currentTaskToProcess = '';
          this.events = events;
          const unassignedTaskStatus = events['unassignedTaskStatus'];
          switch (unassignedTaskStatus) {
            case "none":
              this.unassignedTasks = [];
              this.noUnassignedTasks = true;
              break;
            case "updated":
              this.unassignedTasks = events['unassignedTasks'];
              this.unassignedTasks = this.unassignedTasks.filter(item => item.typeName !== 'OutboundFlight');
              if(this.unassignedTasks && this.unassignedTasks.length>50){
                this.unassignedTasks = this.unassignedTasks.slice(0,50);
              }
              if (this.unassignedTasks && this.unassignedTasks.length > 0) {
                this.updateFormAddOns(this.unassignedTasks);
                this.noUnassignedTasks = false;
              }
              break;
            default:
              break;
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  getStatusColor(taskGroupStatus): string{
    return this.utilityService.getStatusColor(taskGroupStatus);
  }

  checkCustoms(origin): boolean{
    return this.flightCustoms.includes(origin);
  }

  assignTask(taskName: string){
    const adId = this.profileService.profileObs$.getValue().adId;
    if (!this.eventsService.driverHasVan(adId)) {
      this.toastService.show('You do not have a van assigned. Please get a van before assign tasks.', { classname: 'bg-danger text-light', delay: 8000 });
      return;
    }
    this.currentTaskToProcess = taskName;
    const assignTaskPayload: AssignTask = {
      assignTo: this.profileService.profileObs$.getValue().adId,
      taskIds: [taskName],
      type: "assign"
    }
    this.unassignedTasksService.assignTask(assignTaskPayload).subscribe({
      next: (response: HttpResponse<any>) => {
      if(response.status === 204){
        this.eventsDeltaService.getDeltas()
        this.toastService.show(`TASK ASSIGNED SUCCESSFULLY`, { classname: 'bg-success text-light', delay: 6000 });
      }else{
        this.currentTaskToProcess = '';
        this.logger.error(`${response.status} ${response.statusText}`);
        this.toastService.show(`ERROR ${response.status}: TASK WAS NOT ASSIGNED`, { classname: 'bg-danger text-light', delay: 6000 });
      }
      },
      error: () => {
        this.currentTaskToProcess = '';
      }
    });
  }

  updateTasks(): void {
    this.eventsDeltaService.getDeltas();
  }

  getIcon(type: string): string{
    switch (type) {
      case "Other":
        return 'icon-tasks-switch';
      case "Catering":
        return 'icon-cutlery-switch';
      case "Customs":
      case "Paperwork":
        return 'icon-file-switch';
      case "JS":
      case "FO":
      case "CPT":
      case "Passenger":
        return 'icon-user-switch';
      default:
        return 'icon-tasks-switch';
    }
  }
}
